import { css } from "@compiled/react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { templatePreviewRelayFragment$key } from "@/__generated__/templatePreviewRelayFragment.graphql";
import { TemplatePreviewWindow } from "@/components/confluence/templates/template-preview-window";
import { TemplateType } from "@/content/templates/template.types";

interface TemplatePreviewProps {
    template: templatePreviewRelayFragment$key;
    isCfind3646Treatment: boolean;
}

const WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";

const templatePreviewSection = css({
    paddingBlockEnd: 16,
    textAlign: "center"
});

const templatePreviewSectionCfind3646 = css({
    textAlign: "center"
});

const previewBackgroundContainer = css({
    position: "relative",
    paddingBlockEnd: 48,
    paddingInlineEnd: 20,
    paddingInlineStart: 20
});

const previewBackgroundContainerCfind3646 = css({
    position: "relative",
    paddingBlockEnd: 24,
    paddingInlineEnd: 20,
    paddingInlineStart: 20
});

const relativePosition = css({
    "position": "relative",
    "margin": "0 auto",

    "@media (max-width: 39.99rem)": {
        maxWidth: 288
    },
    "@media (min-width: 40rem) and (max-width: 767.99px)": {
        maxWidth: 568
    },
    "@media (min-width: 768px) and (max-width: 1023.99px)": {
        maxWidth: 688
    },
    "@media (min-width: 1024px) and (max-width: 1279.99px)": {
        maxWidth: 648
    }
});

const TemplatePreviewRelayFragment = graphql`
    fragment templatePreviewRelayFragment on ContentPlatformTemplate {
        name
        templateType {
            id
        }
        templatePreviews: templatePreview {
            url
        }
    }
`;

export const TemplatePreview = ({
    template,
    isCfind3646Treatment: isCfind3646Treatment
}: TemplatePreviewProps) => {
    const { name, templateType, templatePreviews } = useFragment(
        TemplatePreviewRelayFragment,
        template
    );

    const templatePreview = templatePreviews?.[0] ?? null;

    if (!templatePreview) {
        return null;
    }

    return (
        <section
            css={[
                isCfind3646Treatment
                    ? templatePreviewSectionCfind3646
                    : templatePreviewSection
            ]}
        >
            {templatePreview && (
                <div
                    css={[
                        isCfind3646Treatment
                            ? previewBackgroundContainerCfind3646
                            : previewBackgroundContainer
                    ]}
                >
                    <div css={relativePosition}>
                        <TemplatePreviewWindow
                            url={templatePreview.url}
                            alt=""
                            templateType={
                                templateType?.[0]?.id === WHITEBOARD_TEMPLATE_ID
                                    ? TemplateType.Whiteboard
                                    : TemplateType.Page
                            }
                        />
                    </div>
                </div>
            )}
        </section>
    );
};
